import { BrowserModule } from '@angular/platform-browser';
import { CurrencyPipe, DatePipe, PercentPipe } from '@angular/common';
import { ErrorHandler, NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { HttpClientModule } from '@angular/common/http';
import { IonicApp, IonicModule } from 'ionic-angular';
import { IonicStorageModule } from '@ionic/storage';
import { StoreDevtoolsModule } from '@ngrx/store-devtools';
import { StoreModule } from '@ngrx/store';

import { AddVehiclePage } from '../pages/add-vehicle/add-vehicle';
import { AddVehiclePageModule } from '../pages/add-vehicle/add-vehicle.module';
import { AddressProvider } from './../providers/address/address';
import { AnalyticsProvider } from '../providers/analytics/analytics';
import { ApiProvider } from '../providers/api/api';
import { AppModeProvider } from '../providers/app-mode/app-mode';
import { CollectionActions } from '../state/actions';
import { ComponentsModule } from './../components/components.module';
import { CustomMapMarker } from '../providers/map/custom-map-marker';
import { DirectionsService } from '../providers/directions/directions';
import { DirectivesModule } from '../directives/directives.module';
import { EmptyStateComponent } from './../components/empty-state/empty-state';
import { EnvironmentProvider } from '../providers/environment/environment';
import {
  ErrorReportingProvider,
  YoshiErrorHandler,
} from '../providers/error-reporting/error-reporting';
import { EtaWarningModalComponent } from '../components/eta-warning-modal/eta-warning-modal';
import { FleetPage } from '../pages/fleet/fleet';
import { FleetPageModule } from '../pages/fleet/fleet.module';
import { InspectionFormService } from '../pages/order-detail/components/order-detail-tasks-list/inspection-form.service';
import { LoadingAlertProvider } from '../providers/loading-alert/loading-alert';
import { LoginFlowPage } from './../pages/flows/login-flow/login-flow';
import { LoginFlowPageModule } from '../pages/flows/login-flow/login-flow.module';
import { LoginPage } from './../pages/login/login';
import { LoginPageModule } from './../pages/login/login.module';
import { MapProvider } from '../providers/map/map';
import { MessageProvider } from '../providers/message/message';
import { MyApp } from './app.component';
import { OnTimePercentageModalComponent } from '../components/on-time-percentage-modal/on-time-percentage-modal';
import { OpsProvider } from '../providers/ops/ops';
import { OpsTabsPage } from '../pages/ops-tabs/ops-tabs';
import { OpsTabsPageModule } from '../pages/ops-tabs/ops-tabs.module';
import { OrderAddNotePage } from '../pages/order-add-note/order-add-note';
import { OrderAddNotePageModule } from './../pages/order-add-note/order-add-note.module';
import { OrderCompletePage } from '../pages/order-complete/order-complete';
import { OrderCompletePageModule } from '../pages/order-complete/order-complete.module';
import { OrderDetailPage } from '../pages/order-detail/order-detail';
import { OrderDetailPageModule } from '../pages/order-detail/order-detail.module';
import { OrderListPage } from './../pages/order-list/order-list';
import { OrderListPageModule } from '../pages/order-list/order-list.module';
import { OrderNavigationPage } from '../pages/order-navigation/order-navigation';
import { OrderNavigationPageModule } from './../pages/order-navigation/order-navigation.module';
import { OrderNotesPage } from '../pages/order-notes/order-notes';
import { OrderNotesPageModule } from './../pages/order-notes/order-notes.module';
import { PipesModule } from '../pipes/pipes.module';
import { ProgressBarComponent } from './../components/progress-bar/progress-bar';
import { SelectVehicleMakePage } from '../pages/select-vehicle-make/select-vehicle-make';
import { SelectVehicleMakePageModule } from './../pages/select-vehicle-make/select-vehicle-make.module';
import { SelectVehicleModelPage } from './../pages/select-vehicle-model/select-vehicle-model';
import { SelectVehicleModelPageModule } from './../pages/select-vehicle-model/select-vehicle-model.module';
import { SessionProvider } from '../providers/session/session';
import { ShiftPage } from '../pages/shift/shift';
import { ShiftPageModule } from '../pages/shift/shift.module';
import { SimpleMessageModalComponent } from './../components/simple-message-modal/simple-message-modal';
import { TrucksPage } from '../pages/trucks/trucks';
import { TrucksPageModule } from '../pages/trucks/trucks.module';
import { UserMessagesPage } from '../pages/user-messages/user-messages';
import { UserMessagesPageModule } from './../pages/user-messages/user-messages.module';
import { UserProvider } from '../providers/user/user';
import { VehicleAutocompletePage } from '../pages/vehicle-autocomplete/vehicle-autocomplete';
import { VehicleAutocompletePageModule } from '../pages/vehicle-autocomplete/vehicle-autocomplete.module';
import { VehicleMileagePage } from '../pages/fleet/mileage/mileage';
import { VehicleMileagePageModule } from '../pages/fleet/mileage/mileage.module';
import { VehicleProvider } from '../providers/vehicle/vehicle';
import { reducerProvider, reducerToken } from './../state/state';

@NgModule({
  declarations: [MyApp],
  imports: [
    BrowserModule,
    IonicModule.forRoot(MyApp, {
      backButtonText: '',
      backButtonIcon: 'md-arrow-round-back',
      tabsHideOnSubPages: true,
      mode: 'ios',
      platforms: {
        ios: {
          statusbarPadding: true,
        },
      },
    }, 
{
  links: [
    { loadChildren: '../pages/add-vehicle/add-vehicle.module.ngfactory#AddVehiclePageModuleNgFactory', name: 'AddVehiclePage', segment: 'add-vehicle', priority: 'low', defaultHistory: [] },
    { loadChildren: '../pages/flows/login-flow/login-flow.module.ngfactory#LoginFlowPageModuleNgFactory', name: 'LoginFlowPage', segment: 'login-flow', priority: 'low', defaultHistory: [] },
    { loadChildren: '../pages/login/login.module.ngfactory#LoginPageModuleNgFactory', name: 'LoginPage', segment: 'login', priority: 'low', defaultHistory: [] },
    { loadChildren: '../pages/ops-tabs/ops-tabs.module.ngfactory#OpsTabsPageModuleNgFactory', name: 'OpsTabsPage', segment: 'ops-tabs', priority: 'low', defaultHistory: [] },
    { loadChildren: '../pages/order-add-note/order-add-note.module.ngfactory#OrderAddNotePageModuleNgFactory', name: 'OrderAddNotePage', segment: 'order-add-note', priority: 'low', defaultHistory: [] },
    { loadChildren: '../pages/order-complete/order-complete.module.ngfactory#OrderCompletePageModuleNgFactory', name: 'OrderCompletePage', segment: 'order-complete', priority: 'low', defaultHistory: [] },
    { loadChildren: '../pages/order-detail/order-detail.module.ngfactory#OrderDetailPageModuleNgFactory', name: 'OrderDetailPage', segment: 'order-detail', priority: 'low', defaultHistory: [] },
    { loadChildren: '../pages/order-navigation/order-navigation.module.ngfactory#OrderNavigationPageModuleNgFactory', name: 'OrderNavigationPage', segment: 'order-navigation', priority: 'low', defaultHistory: [] },
    { loadChildren: '../pages/order-notes/order-notes.module.ngfactory#OrderNotesPageModuleNgFactory', name: 'OrderNotesPage', segment: 'order-notes', priority: 'low', defaultHistory: [] },
    { loadChildren: '../pages/select-vehicle-make/select-vehicle-make.module.ngfactory#SelectVehicleMakePageModuleNgFactory', name: 'SelectVehicleMakePage', segment: 'select-vehicle-make', priority: 'low', defaultHistory: [] },
    { loadChildren: '../pages/select-vehicle-model/select-vehicle-model.module.ngfactory#SelectVehicleModelPageModuleNgFactory', name: 'SelectVehicleModelPage', segment: 'select-vehicle-model', priority: 'low', defaultHistory: [] },
    { loadChildren: '../pages/shift/shift.module.ngfactory#ShiftPageModuleNgFactory', name: 'ShiftPage', segment: 'shift', priority: 'low', defaultHistory: [] },
    { loadChildren: '../pages/user-messages/user-messages.module.ngfactory#UserMessagesPageModuleNgFactory', name: 'UserMessagesPage', segment: 'user-messages', priority: 'low', defaultHistory: [] },
    { loadChildren: '../pages/vehicle-autocomplete/vehicle-autocomplete.module.ngfactory#VehicleAutocompletePageModuleNgFactory', name: 'VehicleAutocompletePage', segment: 'vehicle-autocomplete', priority: 'low', defaultHistory: [] },
    { loadChildren: '../pages/trucks/trucks.module.ngfactory#TrucksPageModuleNgFactory', name: 'TrucksPage', segment: 'trucks', priority: 'low', defaultHistory: [] },
    { loadChildren: '../pages/fleet/fleet.module.ngfactory#FleetPageModuleNgFactory', name: 'FleetPage', segment: 'fleet', priority: 'low', defaultHistory: [] },
    { loadChildren: '../pages/order-list/order-list.module.ngfactory#OrderListPageModuleNgFactory', name: 'OrderListPage', segment: 'order-list', priority: 'low', defaultHistory: [] }
  ]
}),
    StoreModule.forRoot(reducerToken),
    StoreDevtoolsModule.instrument({ maxAge: 5 }),
    IonicStorageModule.forRoot(),
    AddVehiclePageModule,
    ComponentsModule,
    DirectivesModule,
    FleetPageModule,
    FormsModule,
    HttpClientModule,
    OpsTabsPageModule,
    OrderAddNotePageModule,
    OrderCompletePageModule,
    OrderDetailPageModule,
    OrderListPageModule,
    OrderNotesPageModule,
    ShiftPageModule,
    UserMessagesPageModule,
    VehicleAutocompletePageModule,
    PipesModule,
    TrucksPageModule,
    OrderNavigationPageModule,
    LoginPageModule,
    LoginFlowPageModule,
    SelectVehicleMakePageModule,
    SelectVehicleModelPageModule,
    VehicleMileagePageModule,
  ],
  bootstrap: [IonicApp],
  entryComponents: [
    MyApp,
    AddVehiclePage,
    FleetPage,
    OpsTabsPage,
    OrderAddNotePage,
    OrderCompletePage,
    OrderDetailPage,
    OrderListPage,
    OrderNotesPage,
    ProgressBarComponent,
    ShiftPage,
    TrucksPage,
    UserMessagesPage,
    VehicleAutocompletePage,
    OnTimePercentageModalComponent,
    OrderNavigationPage,
    EmptyStateComponent,
    LoginPage,
    LoginFlowPage,
    SimpleMessageModalComponent,
    EtaWarningModalComponent,
    SelectVehicleMakePage,
    SelectVehicleModelPage,
    VehicleMileagePage,
  ],
  providers: [
    // {provide: ErrorHandler, useClass: IonicErrorHandler},
    reducerProvider,
    { provide: ErrorHandler, useClass: YoshiErrorHandler },
    AnalyticsProvider,
    ApiProvider,
    CurrencyPipe,
    DatePipe,
    EnvironmentProvider,
    IonicStorageModule,
    CollectionActions,
    LoadingAlertProvider,
    OpsProvider,
    PercentPipe,
    SessionProvider,
    OpsProvider,
    UserProvider,
    ErrorReportingProvider,
    AppModeProvider,
    CustomMapMarker,
    MapProvider,
    AddressProvider,
    VehicleProvider,
    MessageProvider,
    DirectionsService,
    InspectionFormService,
  ],
})
export class AppModule {}



// WEBPACK FOOTER //
// ./src/app/app.module.ts